import type { OptimizelyDecideOption } from '@optimizely/react-sdk';
import { useDecision } from '@optimizely/react-sdk';
import Cookies from 'js-cookie';

import type { UseOptimizelyDecision, UseOptimizelyDecisionProps } from './useOptimizelyDecision';

export const useOptimizelyDecisionWithCustomUserId = ({
	attributes,
	decideOptions,
	experimentId,
	userId,
}: UseOptimizelyDecisionProps & {
	decideOptions?: OptimizelyDecideOption[];
	userId: string | number;
}): UseOptimizelyDecision => {
	const [decision, clientReady] = useDecision(
		experimentId,
		{ autoUpdate: true, decideOptions },
		{
			overrideAttributes: {
				// Required to block bucketing based on dealership ID we have on the provider level
				$opt_bucketing_id: null,
				...attributes,
			},
			overrideUserId: `${userId}`,
		},
	);

	// This allows us to set decisions in cypress tests. Empty get results in all cookies being returned
	const experimentDecisionCookie = experimentId ? Cookies.get(experimentId) : undefined;

	if (experimentDecisionCookie) {
		return {
			decision: experimentDecisionCookie,
			isEnabled: true,
		};
	}

	if (decision.enabled && clientReady) {
		return {
			decision: decision.variationKey,
			isEnabled: decision.enabled,
		};
	}

	return {
		decision: null,
		isEnabled: false,
	};
};
